import React, { useEffect, useState } from 'react';
import Loading from './Loading';
import VerificationInput from "react-verification-input";

export default function UserTokenVerification({ onSubmit }) {
  const isLoading = false;
  const [token, setToken] = useState('');

  useEffect(() => {
    if (token.length === 6) {
      submitToken(token);
    }
  }, [token]);

  const submitToken = async (givenToken) => {
    onSubmit(givenToken);
    setToken('');
  };

  const verificationInputChanged = (value) => {
    setToken(value);
  };

  if (isLoading) return <Loading spinnerColor="primary-blue" containerClass="p-20 xs:p-40" />;

  return (
    <div role="form">
      <VerificationInput
        autoFocus={true}
        debug={false}
        length={6}
        onChange={verificationInputChanged}
        placeholder="-"
        validChars="0-9"
        value={token}
        inputProps={{ autoComplete: "one-time-code" }}
        classNames={{
          character: 'input border border-light-gray rounded-md mx-1 xxs:mx-1 flex justify-center items-center cursor-pointer text-navy-blue text-lg',
          container: 'w-full tokens my-4 xxs:my-8 flex justify-center items-center h-16 font-avenir-black',
          characterInactive: 'text-light-gray bg-white',
          characterSelected: 'border-primary-blue border-2',
        }}
      />
    </div>
  );
}
